// @flow
import React from 'react';
import classnames from 'classnames';

import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';
import { TrackClick } from 'Tracking/track-click/TrackClick.jsx';

import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink.jsx';
import { Icon } from 'Components/frameworks/icon/Icon.jsx';
import { Text } from 'Components/frameworks/text/Text.jsx';

import { themes } from './DownloadLinksList.themes';

export type DownloadLinksListItem = {
  iconName?: string,
  label: string,
  onClick?: (SyntheticEvent<>) => *,
  target?: '_blank' | '_self',
  trackingData?: TrackingData,
  url: string,
};

type Props = {
  className?: string,
  links: Array<DownloadLinksListItem>,
  text?: string,
  theme?: string,
};

export function DownloadLinksList(props: Props) {
  const { className, links = [], text, theme = 'default' } = props;

  if (!links.length) {
    return null;
  }

  const {
    thLabel,
    thLabelIconSize,
    thLink,
    thList,
    thListItem,
    thListItemIcon,
    thListItemIconSize,
    thRoot,
    thText,
  } = themes[theme];

  return (
    <section className={classnames(className, thRoot)}>
      {!!text && (
        <div className={thLabel}>
          <Icon
            className="flex-shrink-0"
            color={COLORS.BLUE}
            name={ICONS.DOWNLOAD}
            width={thLabelIconSize}
          />
          <Text className={thText} text={text} />
        </div>
      )}
      <ul className={thList}>
        {links.map(
          ({ iconName, label, onClick, target, trackingData, url }) =>
            url && label ? (
              <li className={thListItem} key={label}>
                <Icon className={thListItemIcon} name={iconName} width={thListItemIconSize} />
                <TrackClick
                  as={DynamicLink}
                  trackingData={trackingData}
                  className={thLink}
                  onClick={onClick}
                  target={target}
                  url={url}
                >
                  {label}
                </TrackClick>
              </li>
            ) : null,
        )}
      </ul>
    </section>
  );
}
